import React from 'react';
import ParticleBackground from '../../ParticleBackground';
import Navbar from './Navbar';
import Typed from 'typed.js';
import './Slider.css'
import { useEffect } from 'react';
import SliderInfo from './SliderInfo';


const Slider = ({ user, SetOpen, SignOutAccount }) => {    
    var options = {
        strings: ['Web Developer', 'Programmer', 'Blogger'],
        typeSpeed: 60,
        loop: true,
        loopCount: Infinity,
        smartBackspace: false,
        backDelay: 2000
    };
      
    useEffect(() => {
        var typed = new Typed('.element', options);
    }, [])
    
    return (
        <>
            <div className='slider_main_container'>
                <Navbar userInfo={user} SetOpen={SetOpen} SignOutAccount={SignOutAccount}/>
                <ParticleBackground />
                <SliderInfo />
            </div>
        </>
    );
};

export default Slider;